<template>
  <div class="updateversion">
    <div class="box">
      <div class="container">
        <div class="content">
          <div class="bg_top">
            <img src="../../assets/img/update/newversion.png" alt>
          </div>
          <div class="bg_bottom">
            <p class="title">
              狸米新启航
              <span class="version">{{version}}</span>
            </p>
            <ul>
              <li v-for="(txt,idx) in description" :key="idx">{{txt}}</li>
            </ul>
            <p class="btnbox" v-if="datas.type==1">
              <button class="confirmBtn cursor" @click="updateNow">立即更新</button>
            </p>
            <p class="btnbox1" v-else-if="datas.type==0">
              <button class="cancelBtn cursor" @click="cancel">暂不更新</button>
              <button class="confirmBtn cursor" @click="updateNow">立即更新</button>
            </p>
            <p class="cursor problem" @click="gopage">遇到安装问题？点击这里~</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import common from "common";
import utils from "utils";
if (LIMI_ENV === "electron") {
  var ipc = window.require("electron").ipcRenderer;
}
export default {
  name: "updateversion",
  data() {
    return {
      updateType: 0
    };
  },
  props: {
    datas: {
      type: Object
    }
  },
  computed: {
    ...mapState(["userID"]),
    description() {
      return this.datas.description.split("\n");
    },
    version() {
      let str = this.datas.version.split(".");
      return str.length > 3
        ? this.datas.version.substr(0, this.datas.version.lastIndexOf("."))
        : this.datas.version;
    }
  },
  mounted() {
    this.$root.eventHub.$emit("createLog", {
      id: "LMTrackEventVersionNotice",
      data: {}
    });
  },
  methods: {
    ...mapActions(["getLatestVersion"]),
    gopage(){
      this.$router.push({
          path:"/advice",
          query:{
            from:"update"
          }
        });
    },
    //重启app
    updateNow() {
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventUpdate",
        data: {}
      });
      common.set("promptUpdate", true);
      ipc.send("restartApp");
    },
    cancel() {
      this.$root.eventHub.$emit("showPopup", "a_update");
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventUpdateCancel",
        data: {}
      });
    }
  }
};
</script>
<style  lang="less" rel="stylesheet/less" scoped>
.updateversion {
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  .box {
    position: absolute;
    width: 520px;
    height: 447px;
    left: 50%;
    top: 50%;
    margin-top: -230px;
    margin-left: -260px;
  }
  .bg_top {
    width: 100%;
    height: 149px;
    background: url("../../assets/img/update/bg_top.png") no-repeat center top;
    background-size: 520px 149px;
    text-align: center;
  }

  .bg_top img {
    margin-top: 46px;
    height: 33px;
    vertical-align: middle;
  }

  .bg_bottom {
    height: 310px;
    background: #fff;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    text-align: left;
    padding-top: 25px;
  }

  .bg_bottom ul {
    padding-left: 60px;
    list-style-type: decimal;
    font-size: 18px;
    color: #003057;
    height: 105px;
    overflow: hidden;
  }
  .bg_bottom li {
    height: 26px;
    line-height: 26px;
    overflow: hidden;
    white-space: nowrap;
    margin-right: 30px;
  }
  .bg_bottom .title {
    font-size: 23px;
    color: #003057;
    padding-left: 60px;
    margin-bottom: 15px;
    font-family: PingFang_Medium;
    font-weight: bold;
  }

  .bg_bottom .version {
    font-size: 23px;
    color: #003057;
    margin-left: 20px;
  }

  .bg_bottom .btnbox,
  .bg_bottom .btnbox1 {
    text-align: center;
    margin-top: 17px;
  }
  .bg_bottom button {
    background: none;
    outline: none;
    width: 180px;
    height: 54px;
    border-radius: 27px;
    font-size: 22px;
    line-height: 54px;
  }
  .bg_bottom .confirmBtn {
    background-color: #008acf;
    color: #ffffff;
  }
  .bg_bottom .cancelBtn {
    border: solid 1px #0073ae;
    color: #0073ae;
  }
  .bg_bottom .btnbox .confirmBtn {
    width: 280px;
  }
  .bg_bottom .btnbox1 .confirmBtn {
    margin-left: 25px;
  }
  .cancelBtn:hover {
    border-color: #4c9dc7;
    color: #4c9dc7;
  }
  .confirmBtn:hover {
    background-color: #4cadde;
  }
  .problem{
    color:#1492d2;
    text-align: center;
    font-size: 18px;
    padding: 15px 0;
  }
  .problem:hover{
    color: #7bc2e6;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basic/updateversion.vue